import NoResultsMessage from '@molecules/NoResultsMessage'
import { eventBus } from '@/main'
export default {
  components: {
    NoResultsMessage
  },
  data() {
    return {
      tick: 1,
      loaded: false,
      err: false,
      submitting: false,
      groupName: '',
      groupId: '',
      subGroupName: '',
      subGroupId: ''
    }
  },
  computed: {
    queryParams: function() {
      return this.$store.state.queryStringHelper.queryParams
    },
    searchTerm: function() {
      if (this.whiteListedQueryParams === undefined) {
        return ''
      }

      return this.whiteListedQueryParams
        .filter((p) => this.queryParams[p]).map((p) => '"' + this.queryParams[p] + '"')
        .join(', ')
    }
  },
  methods: {
    initSearch() {
      this.loaded = false
      if (this.whiteListedQueryParams === undefined) {
        return
      }
      this.whiteListedQueryParams.forEach((param) => {
        if (this[param] !== undefined) {
          this[param] = this.queryParams[param]
        }
      })
      this.search()
      eventBus.$emit('searchParamsParsed')
    }
  },
  created() {
    this.initSearch()
  },
  watch: {
    queryParams(newVal) {
      this.initSearch()
    }
  }
}
